import type { ReactElement, ReactNode } from 'react';
import type { CSSObject } from '@mui/material';
import { Stack } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import type { PpWC } from '@noah-labs/fe-shared-ui-shared';
import { Element } from 'react-scroll';
import type { PpSeo } from '../layout/Seo';
import { Seo } from '../layout/Seo';

type PpBaseWrapper = PpWC & {
  FooterSlot?: ReactNode;
  HeaderSlot: ReactNode;
  marginTop?: CSSObject['marginTop'];
  pageBackgroundColor?: 'lighterGrey' | 'white';
  seoProps?: PpSeo | null;
};
const StyledMain = styled('main')(() => ({
  flexGrow: 1,
  position: 'relative',
}));

export function BaseWrapper({
  children,
  FooterSlot,
  HeaderSlot,
  marginTop = 0,
  pageBackgroundColor = 'white',
  seoProps,
}: PpBaseWrapper): ReactElement {
  const theme = useTheme();
  const backgroundColor = theme.palette.websiteBrand.greyscale[pageBackgroundColor];
  return (
    <Stack height="100%" minWidth="300px" sx={{ backgroundColor }}>
      <Seo {...seoProps} />
      {HeaderSlot}
      <Element name="top" />
      <StyledMain sx={{ marginTop }}>{children}</StyledMain>
      {FooterSlot}
    </Stack>
  );
}
